export const PAGE_SIZE = 50;

export const STATUS_OPTIONS = [
    { value: 'NOT_STARTED', label: 'Not started' },
    { value: 'IN_PROGRESS', label: 'In progress' },
    { value: 'AT_RISK', label: 'At risk' },
    { value: 'BLOCKED', label: 'Blocked' },
    { value: 'COMPLETE', label: 'Complete' },
    { value: 'ON_HOLD', label: 'On hold' },
    { value: 'NOT_APPLICABLE', label: 'Not applicable' },
    { value: 'UNKNOWN', label: 'Unknown' },
];

export const MIGRATION_TYPES = ['Integration', 'Separation', 'Carve-out', 'Selective integration', 'Transfer', 'Retain', 'Replacement', 'Other', 'Not specified'];

export const COLUMN_DEFS = [
    { id: 'item', label: 'Item / Description' },
    { id: 'function', label: 'Business Function' },
    { id: 'migration', label: 'Migration Type' },
    { id: 'owner', label: 'Owner' },
    { id: 'status', label: 'Status' },
    { id: 'date', label: 'Target Date' },
    { id: 'attention', label: 'Attention' },
    { id: 'source', label: 'Source Worksheet' },
    { id: 'description', label: 'Description' },
    { id: 'custom', label: 'Custom Fields' },
];

export const DEFAULT_COLUMNS = {
    item: true,
    function: true,
    migration: true,
    owner: true,
    status: true,
    date: true,
    attention: true,
    source: true,
    description: false,
    custom: false,
};

export const SHEET_PURPOSES = [
    ['activities', 'Project activities / actions'],
    ['systems', 'Systems & services'],
    ['people', 'People / resources'],
    ['migration_items', 'Migration items'],
    ['transition_services', 'Transition services'],
    ['risks', 'Risks / issues'],
    ['milestones', 'Milestones'],
    ['supporting', 'Supporting / reference information'],
    ['relationship', 'Relationship only'],
    ['other', 'Other / not sure'],
];

export const FIELD_TARGETS = [
    ['title', 'Item / Title'],
    ['description', 'Description'],
    ['business_function', 'Business function'],
    ['migration_type', 'Migration type'],
    ['owner', 'Owner'],
    ['status', 'Status'],
    ['target_date', 'Target date'],
    ['external_id', 'Code'],
    ['notes', 'Notes'],
    ['custom', 'Keep as custom'],
];

export const WIZARD_STEPS = ['Upload', 'Worksheets', 'Match fields', 'Review changes', 'Finish'];

export const ATTENTION_REASONS = ['BLOCKED', 'AT_RISK', 'OVERDUE', 'MISSING_OWNER', 'DUE_SOON', 'UNMAPPED_STATUS', 'MISSING_TARGET_DATE', 'SOURCE_CONFLICT'];

export const SORT_KEYS = {
    item: 'title',
    function: 'business_function',
    status: 'status',
    date: 'target_date',
    owner: 'owner',
};

export function statusLabel(value) {
    return STATUS_OPTIONS.find(option => option.value === value)?.label || value || 'Unknown';
}

export function emptyAddForm() {
    return {
        title: '',
        businessFunction: '',
        owner: '',
        status: 'NOT_STARTED',
        migrationType: 'Not specified',
        targetDate: '',
    };
}

export function resetColumns() {
    return { ...DEFAULT_COLUMNS };
}
